<template>
  <div id="install-device">
    <div class="module-search">
      <!-- <el-input placeholder="请输入关键字" v-model="searchContent" class="input-with-select">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input> -->

      <el-button
        v-if="isShow"
        :disabled="!isMore"
        :title="moretitle"
        class="search-btn"
        type="primary"
        icon="el-icon-plus"
        @click="handleMoreBtn"
      >
        批量分配
      </el-button>
    </div>

    <div class="table-box">
      <el-table
        ref="multipleTable"
        v-loading="tableLoading"
        :data="tableList"
        :show-overflow-tooltip="true"
        class="module-main"
        style="width: 100%"
        header-row-class-name="table-header"
        row-class-name="table-row"
        @selection-change="handleSelection"
      >
        <el-table-column v-if="isShow" type="selection"></el-table-column>
        <el-table-column show-overflow-tooltip prop="name4Company" label="设备名称" align="center" />
        <el-table-column show-overflow-tooltip prop="groupName" label="产品型号" align="center" />
        <el-table-column show-overflow-tooltip prop="code" label="设备编号" align="center" />
        <el-table-column show-overflow-tooltip prop="guid" label="GUID" align="center" />
        <el-table-column show-overflow-tooltip prop="imei" label="IMEI" align="center" />
        <!-- <el-table-column show-overflow-tooltip prop="mac" label="MAC地址" align="center" /> -->
        <el-table-column show-overflow-tooltip prop="allotDeptName" label="分配部门" align="center" />
        <el-table-column show-overflow-tooltip prop="brand" label="品牌" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span class="table-detail" @click="handleClickDetail(scope.row.id)">详情</span>
            <!-- <span class='table-detail' @click='handleClickDistry(scope.row.id)'>分配</span> -->
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :total="pagination.total"
        :page-size="pagination.pageSize"
        :current-page="pagination.pageIndex"
        background
        class="pagination"
        layout="prev, pager, next"
        @current-change="changePageData"
      />
    </div>

    <el-dialog
      :visible.sync="addUserDialogVisibility"
      custom-class="add-user-dialog"
      title="设备详情"
      width="960px"
      @closed="handleAddUserDialogClosed"
    >
      <div class="input-info">
        <span class="title"><span>*</span>设备名称:</span>
        <el-input v-model="addUserDialogData.name4Company" disabled placeholder="请输入内容" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>产品型号:</span>
        <el-input v-model="addUserDialogData.groupName" disabled placeholder="请输入内容" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>设备编码:</span>
        <el-input v-model="addUserDialogData.code" disabled placeholder="请输入内容" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>品牌:</span>
        <el-input v-model="addUserDialogData.brand" disabled placeholder="请输入内容" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>GUID:</span>
        <el-input v-model="addUserDialogData.guid" disabled placeholder="请输入内容" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>IMEI:</span>
        <el-input v-model="addUserDialogData.imei" disabled placeholder="请输入内容" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>MAC:</span>
        <el-input v-model="addUserDialogData.mac" disabled placeholder="请输入内容" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>分配部门:</span>
        <el-input v-model="addUserDialogData.allotDeptName" disabled placeholder="请输入内容" />
      </div>
    </el-dialog>

    <!-- 分配 -->
    <el-dialog
      :visible.sync="distributDialogVisibility"
      custom-class="add-user-dialog"
      title="设备详情"
      width="640px"
      @closed="() => distributDialogVisibility = false"
    >
      <div class="input-info">
        分配公司:
        <base-cascader
          v-model="allotDeptId"
          clearable
          expand-trigger="hover"
          :show-all-levels="false"
          placeholder="请选择"
          :props="defaultProps"
          :options="deptDict"
          change-on-select
          @change="handleChange"
        />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="certain-btn" type="primary" @click="handleSuredistribut">分配</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BaseCascader from '@/components/BaseCascader'
import { roleNames } from '@/config.js'

export default {
  name: 'NotInstallDevice',
  components: {
    BaseCascader,
  },
  data () {
    return {
      tableLoading: true,
      addUserDialogVisibility: false,
      searchContent: '',
      roleListData: [],
      // 列表样式
      tableList: [
        // {
        //   inTime: '1',
        //   name4Company: '10001',
        //   code: 'ST05441',
        //   guid: 'ST05441',
        //   imei: 'ST05441',
        //   mac: 'ST05441',
        //   brand: 'ST05441',
        // },
      ],
      // 分页数据
      pagination: {
        // 一共多少页
        pageCount: 1,
        // 第几页
        pageIndex: 1,
        // 一页显示多少个
        pageSize: 10,
        // 总个数
        total: 0,
      },
      // 添加人员弹窗数据
      addUserDialogData: {
        name4Company: '',
        code: '',
        brand: '',
        guid: '',
        imei: '',
        mac: '',
        installPosition: '',
        allotDeptName: '',
      },
      moretitle: '',
      isMore: false,
      isShow: false,
      ids: '',
      distributDialogVisibility: false,
      allotDeptId: '',
      allotDeptName: '',
      defaultProps: {
        children: 'childs',
        label: 'name',
        value: 'id',
      },
      deptDict: [], // 单位字典
    }
  },
  computed: {
  },
  created () {
    let { pagination: { pageIndex, pageSize } } = this
    this.getListReq({ pageIndex, pageSize })
    this.getDicByType()
  },
  methods: {
    /**
     * 处理childs为空数组时移除
     */
    reduce (list) {
      return list.map(({ childs, ...rest }) => {
        return childs && childs.length
          ? { ...rest, childs: this.reduce(childs) }
          : { ...rest }
      })
    },
    /**
     * @description: 获取单位管理里的列表作为可分配部门
     * @return       {undefind} [undefind]
     */
    getDicByType () {
      let roles = this.$store.state.roles.map(({ name }) => name)

      // 只有超级管理员才能分配顶级部门（无）
      if (roles.includes(roleNames.system)) this.isShow = true

      this.$http.post('/api/json/dept/showAllInfo').then(res => {
        if (res.code === 'success') {
          let { list } = res.data

          let listTemp = list && this.reduce(list)

          this.allotDeptId = listTemp && [listTemp[0].id]
          this.allotDeptName = listTemp && listTemp[0].name
          this.deptDict = listTemp
        }
      })
    },
    /**
     * @description: 请求列表
     * @param        {object} params [请求列表参数]
     */
    getListReq (params) {
      this.tableLoading = true
      this.$http.get('/api/device-info/list-install', { ...params, type: 1 }).then(res => {
        this.tableLoading = false
        // this.$http.get('/api/device-info/list', params).then(res => {
        if (res.code === 'success') {
          let { list, pageCount, total } = res.data
          // 与测试约定，这里领用部门（allotDeptName）没有值时，取分配部门字段（allotCompany）
          this.tableList = list.map(item => {
            let { allotCompany, allotDeptName } = item
            if (!allotDeptName) item.allotDeptName = allotCompany
            return item
          })
          this.pagination.pageCount = pageCount
          this.pagination.total = total
        }
      })
    },
    changePageData (e) {
      let { pagination: { pageSize }, searchContent } = this

      this.getListReq({ pageIndex: e, pageSize, searchContent })
    },
    handleSearch () {
      let { pagination: { pageIndex, pageSize }, searchContent } = this

      this.getListReq({ pageIndex, pageSize, searchContent })
    },
    handleAddUserDialogClosed () {
      this.addUserDialogVisibility = false
    },
    // 详情
    handleClickDetail (id) {
      let loadObj = this.$loading({ target: document.querySelector('.add-user-dialog') })
      this.addUserDialogVisibility = true

      this.$http.get('/api/device-info/show', { id }).then(res => {
        loadObj.close()
        if (res.code === 'success') {
          let { allotCompany, allotDeptName } = res.data
          this.addUserDialogData = res.data

          if (!allotDeptName) this.addUserDialogData.allotDeptName = allotCompany
        }
      })
    },
    /**
     * @description: 改变table选择状态时的触发函数
     * @param        {Array} selection 表示选中的设备信息列表
     * @return       {undefint}   [undefint]
     */
    handleSelection (selection) {
      this.isMore = false
      this.moretitle = '请先选择设备！'

      if (!selection.length) return

      this.isMore = true
      this.moretitle = ''

      this.ids = selection.reduce((total, item) => ([...total, item.id]), []).join(',')
    },
    // 分配领用按钮
    handleMoreBtn () {
      this.distributDialogVisibility = true
    },
    /**
     * @description: 选择分配公司
     * @param        {[type]} e [description]
     * @return       {[type]}   [description]
     */
    handleChange (e) {
      let self = this
      let eId = e[e.length - 1]
      // this.allotDeptId = eId

      flatArr(this.deptDict)
      function flatArr (list) {
        list.find(item => {
          let { childs, id, name } = item
          if (id === eId) (self.allotDeptName = name)
          if (childs && childs.length) flatArr(childs)
        })
      }
      // let temp = this.deptDict.filter(({ id }) => id === eId)

      // if (temp.length) this.allotDeptName = temp[0].name
    },
    // 添加分配-单个
    handleSuredistribut () {
      let { allotDeptId, allotDeptName, ids } = this
      console.log(123, allotDeptId)

      let params = {
        allotDeptId: allotDeptId[allotDeptId.length - 1],
        allotDeptName,
        ids,
      }

      this.$http.post('/api/device-info/receive-dept', params).then(res => {
        if (res.code === 'success') {
          this.distributDialogVisibility = false

          this.$message({ message: '分配成功', type: 'success' })

          this.$refs.multipleTable.clearSelection()
          this.getListReq({ pageIndex: this.pagination.pageIndex, pageSize: 10 })
        } else {
          this.$message.error(`分配失败，${res.msg}`)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
#install-device {
  .module-search {
    // border: 1px solid red;
    height: 30px;
    .input-with-select {
      width: 500px;
    }

    /deep/ .el-input {
      input {
        padding-right: 0px;

        &::-webkit-input-placeholder {
          font-size: 14px;
        }
      }
    }

    /deep/ .search-btn {
      padding: 10px 25px;
      border-radius: 3px;
      margin-left: 50px;
      border: 1px solid #5294d6;
      color: #5294d6;
      background: #fff;
      float: right;

      &:hover {
        background-color: fade(#5294d6, 10);
        color: #5294d6;
      }
    }
  }
  .table-box {
    margin-top: 20px;
    .module-main {
      .delete-tag {
        color: #f06366;
        text-decoration: underline;
        margin-left: 3px;
        cursor: pointer;
      }
      .table-detail {
        color: #409EFF;
        margin-right: 10px;
        cursor: pointer;
      }

      .green {
        color: #4dd292;
      }

      .red {
        color: #f06366;
      }

      .blue-btn {
        width: 72px;
        background-color: #5294d6;
        // margin-left: 5px;

        &:hover {
          background-color: fade(#5294d6, 85);
        }
      }

      .red-btn {
        background-color: #f06366;
        margin-left: 5px;

        &:hover {
          background-color: fade(#f06366, 80);
        }
      }

      .look-details {
        color: #5294d6;
        text-decoration: underline;
        cursor: pointer;
      }

      /deep/ .table-header {
        color: #333;
        font-size: 14px;
        font-weight: bold;

        th {
          // height: 40px !important;
          // padding: 0px;
          text-align: center !important;
          line-height: 25px;
          background-color: #e9f0fa;
        }
      }

      /deep/ .table-row {
        color: #333;
        font-size: 14px;

        .numbering {
          color: #5294d6;
          text-decoration: underline;
          cursor: pointer;
        }

        td {
          padding: 12px 0;
        }
      }
    }
    .table-delete {
      color: #F56C6C;
    }
    .pagination {
      padding: 31px 0;
      height: 32px;
      text-align: center;
      font-weight: normal;

      /deep/ .number {
        background-color: #fff;
        border: 1px solid #e1e1e1;
        padding: 2px 5px;
        height: 32px;
        min-width: 32px;
      }

      /deep/ .active {
        border: none;
        background-color: #4078dd;
      }

      /deep/ .btn-prev {
        width: 32px;
        height: 32px;
      }

      /deep/ .btn-next {
        width: 32px;
        height: 32px;
      }

      /deep/ .more {
        width: 32px;
        height: 32px;
        line-height: 35px;
      }
    }
  }
  /deep/ .add-user-dialog,
  /deep/ .modify-user-data-dialog {
    .el-dialog__header {
      height: 40px;
      padding: 0px;
      line-height: 40px;
      text-indent: 20px;
      background-color: #214f88;
    }

    .el-dialog__headerbtn {
      margin-top: -6px;
    }

    .el-dialog__header .el-dialog__title {
      font-size: 16px;
      color: #fff;
    }

    .el-dialog__body {
      padding: 30px 20px 30px 55px;
      // min-height: 485px;
      overflow: auto;
    }

    .input-info {
      float: left;
      margin-bottom: 13px;
      width: 320px;
      text-align: right;

      .title>span {
        display: none;
        color: red;
        margin-right: 3px;
      }

      &:nth-child(even) {
        margin-left: 160px;
      }

      .el-input {
        width: 240px;
        margin-left: 10px;

        input {
          height: 36px;
        }
      }

      .el-cascader {
        .el-cascader__label {
          text-indent: 13px;
        }
      }

      &.long {
        box-sizing: border-box;
        clear: both;
        width: 100%;
        margin-left: 0px;
        padding-right: 85px;

        .el-input {
          width: 720px;
        }
      }

      .info-content {
        color: #c4c3c3;
        font-size: 12px;
      }

      .el-select__tags {
        text-align: left;
        padding-left: 15px;
      }
    }

    .radio-info {
      float: left;
      margin-bottom: 13px;
      height: 36px;
      line-height: 36px;
      width: 320px;

      &:nth-child(3) {
        margin-left: 33px;
      }

      &:nth-child(4) {
        margin-left: 160px;
      }

      .el-radio-group {
        margin-left: 10px;
      }
    }
  }
}
</style>
